/* Email popup (sections/ss-email-popup.liquid). Hand-written, not generated by build_theme.py. */
(function(){
  'use strict';
  var KEY='ss_pop',PEND='ss_pop_pending',DAY=864e5;
  var current=null;

  function lsGet(k,s){try{return JSON.parse((s||localStorage).getItem(k)||'null')}catch(e){return null}}
  function lsSet(k,v,s){try{(s||localStorage).setItem(k,JSON.stringify(v))}catch(e){}}
  function lsDel(k,s){try{(s||localStorage).removeItem(k)}catch(e){}}

  var NS={preventScroll:true};
  function init(root){
    if(!root||root._ssPop)return;root._ssPop=true;current=root;
    var d=root.dataset,box=root.querySelector('.ss-pop__box'),form=root.querySelector('form'),
        email=root.querySelector('.ss-pop__email'),tagsIn=root.querySelector('[data-pop-tags]'),
        err=root.querySelector('.ss-pop__err'),submit=root.querySelector('.ss-pop__submit'),
        stateEl=root.querySelector('[data-pop-state]'),opts=[].slice.call(root.querySelectorAll('.ss-pop__opt'));
    var design=d.design==='true',days=+d.days||7,delay=(+d.delay||0)*1000;
    var force=/[?&]ss_popup=1(&|$)/.test(location.search);
    var baseTags=(d.tags||'').split(',').map(function(t){return t.trim()}).filter(Boolean);
    var isOpen=false,step=1,mot=null,lastFocus=null,timer=null;
    var touch=window.matchMedia&&matchMedia('(hover:none),(pointer:coarse)').matches;

    function remember(s){
      lsSet(KEY,{s:s,t:Date.now()});
      var age=s==='sub'?63072000:days*86400;
      document.cookie=KEY+'='+s+';path=/;max-age='+age+';SameSite=Lax';
    }
    function suppressed(){
      if(/(?:^|;\s*)ss_pop=/.test(document.cookie))return true;
      var o=lsGet(KEY);if(!o)return false;
      return o.s==='sub'||Date.now()<o.t+days*DAY;
    }

    function stepEl(n){return root.querySelector('[data-step="'+n+'"]')}
    function focusables(){
      return [].slice.call(box.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),[tabindex]:not([tabindex="-1"])'))
        .filter(function(el){return el.getClientRects().length&&!el.closest('[hidden]')});
    }
    function showStep(n,focus){
      step=n;
      if(n===2)protect();
      [1,2,3].forEach(function(i){var s=stepEl(i);if(s)s.hidden=i!==n});
      root.classList.toggle('is-step-2',n===2);root.classList.toggle('is-step-3',n===3);
      var h=stepEl(n).querySelector('.ss-pop__h');
      if(h)box.setAttribute('aria-labelledby',h.id);
      root.querySelector('.ss-pop__body').scrollTop=0;
      if(focus===false||!isOpen)return;
      if(n===2&&!touch)email.focus(NS);
      else if(n===1&&!touch&&opts[0])opts[0].focus(NS);
      else if(h)h.focus(NS);
    }

    /* SHORT = the short Morning Person / Purist page (html.ss-short, phones only: max-width:749px); everywhere else,
       and on tablets and desktop, the popup behaves as before. */
    var SHORT=document.documentElement.classList.contains('ss-short');
    /* paid landing mode (snippets/ss-paid-mode.liquid): utm_medium=paid or WELCOME25 applied, for the session.
       It only turns the popup off on the short phone page; desktop, tablets and other pages keep the live behavior. */
    function paid(){
      if(!SHORT)return false;
      if(document.documentElement.classList.contains('ss-paid'))return true;
      try{return sessionStorage.getItem('ss_paid')==='1'}catch(e){return false}
    }
    function blocked(){
      var dr=document.getElementById('drawer'),mn=document.querySelector('.mnav');
      return (dr&&dr.classList.contains('show'))||document.querySelector('.modal.show')||(mn&&!mn.hidden&&mn.getClientRects().length)||document.fullscreenElement;
    }
    function tryOpen(){
      if(isOpen||current!==root)return;
      if(!force&&!design&&(suppressed()||paid()))return;
      if(blocked()){clearTimeout(timer);timer=setTimeout(tryOpen,3000);return}
      open(1);
    }
    function open(n){
      if(isOpen){showStep(n);return}
      clearTimeout(timer);
      lastFocus=document.activeElement;isOpen=true;
      root.hidden=false;document.documentElement.classList.add('ss-pop-open');
      showStep(n,false);
      box.getBoundingClientRect();
      requestAnimationFrame(function(){root.classList.add('is-open');showStep(n)});
      if(!design&&!force&&n===1)remember('seen');
    }
    function close(){
      if(!isOpen)return;isOpen=false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('ss-pop-open');
      var o=lsGet(KEY);
      if(!design&&!(o&&o.s==='sub'))remember('closed');
      setTimeout(function(){if(!isOpen)root.hidden=true},380);
      if(lastFocus&&lastFocus.focus)lastFocus.focus(NS);
    }

    function pick(btn){
      opts.forEach(function(b){b.setAttribute('aria-pressed',b===btn?'true':'false')});
      var b=btn.dataset;mot=b;
      /* on a product page the match is always that product; an answer written for another product gets the generic copy */
      var cur=SHORT&&d.curHandle,p=cur?{name:d.curName,line:d.curLine,img:d.curImg,shop:d.curShop}:b,other=cur&&b.handle!==d.curHandle;
      root.querySelector('[data-pop-heading]').textContent=other?'Good pick.':(b.heading||'');
      root.querySelector('[data-pop-text]').textContent=other?'Tell us where to send your code.':(b.text||'');
      root.querySelector('[data-pop-name]').textContent=p.name||'';
      root.querySelector('[data-pop-line]').textContent=p.line||'';
      var img=root.querySelector('[data-pop-img]');img.src=p.img||'';img.alt=p.name||'';
      var shop=root.querySelector('[data-pop-shop]');shop.href=p.shop||shop.href;
      root.querySelector('[data-pop-shop-label]').textContent='Shop '+(p.name||'now');
      tagsIn.value=baseTags.concat(b.slug?['motivation-'+b.slug]:[]).join(', ');
      clearErr();
    }
    function bySlug(s){return opts.filter(function(b){return b.dataset.slug===s})[0]||opts[0]}

    function clearErr(){err.hidden=true;err.textContent='';email.removeAttribute('aria-invalid')}
    function showErr(msg){err.textContent=msg;err.hidden=false;email.setAttribute('aria-invalid','true')}
    var busyT;
    function busy(on){submit.setAttribute('aria-busy',on?'true':'false');clearTimeout(busyT);if(on)busyT=setTimeout(function(){busy(false)},15000)}
    function success(){
      lsDel(PEND,sessionStorage);remember('sub');busy(false);
      if(!isOpen)open(3);else showStep(3);
    }

    /* Shopify's bot protection (hCaptcha) on customer forms. Its storefront script binds a form lazily, and once
       bound it cancels the submit, fetches an invisible token and posts the form natively. A submit before the
       form is bound is dropped, so bind it as soon as the email step shows and hold the first submit until then.
       The form must be posted natively: a fetch or HTMLFormElement.prototype.submit skips the token. */
    function captcha(){var S=window.Shopify;return S&&S.captcha&&typeof S.captcha.protect==='function'?S.captcha:null}
    function bound(){return form.hasAttribute('data-hcaptcha-bound')||form.hasAttribute('data-recaptcha-bound')}
    function protect(){var c=captcha();if(!c||form._ssProt||bound())return;form._ssProt=true;try{c.protect(form,function(){})}catch(e){}}
    function resubmit(){if(typeof form.requestSubmit==='function')form.requestSubmit();else form.submit()}

    form.addEventListener('submit',function(e){
      var v=email.value.trim();email.value=v;
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){e.preventDefault();e.stopImmediatePropagation();showErr('Enter a valid email, like you@example.com.');email.focus(NS);return}
      clearErr();
      lsSet(PEND,{slug:mot?mot.slug:'',email:v,t:Date.now()},sessionStorage);
      busy(true);
      if(captcha()&&!bound()){
        e.preventDefault();protect();
        var t0=Date.now();
        (function wait(){
          if(bound())return resubmit();
          if(Date.now()-t0>10000){busy(false);showErr('The spam check didn’t load. Please try again.');return}
          setTimeout(wait,150);
        })();
      }
    });
    window.addEventListener('pageshow',function(e){if(e.persisted)busy(false)});

    root.addEventListener('click',function(e){
      var t=e.target;
      if(t.closest('[data-pop-close]')){e.preventDefault();close();return}
      if(t.closest('[data-pop-back]')){showStep(1);return}
      var o=t.closest('.ss-pop__opt');if(o){pick(o);showStep(2);return}
      var c=t.closest('[data-pop-copy]');if(c)copy(c);
    });
    email.addEventListener('input',function(){if(!err.hidden)clearErr()});

    function copy(btn){
      var code=root.querySelector('[data-pop-code]').textContent.trim(),live=root.querySelector('[data-pop-copied]');
      function done(ok){btn.textContent=ok?'Copied':'Select it';if(live)live.textContent=ok?'Code copied':'';setTimeout(function(){btn.textContent='Copy'},2200)}
      if(navigator.clipboard&&window.isSecureContext){navigator.clipboard.writeText(code).then(function(){done(true)},function(){done(fallback(code))})}
      else done(fallback(code));
    }
    function fallback(code){
      var ta=document.createElement('textarea');ta.value=code;ta.setAttribute('readonly','');ta.style.cssText='position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta);ta.select();var ok=false;try{ok=document.execCommand('copy')}catch(e){}ta.remove();
      if(!ok){var r=document.createRange();r.selectNodeContents(root.querySelector('[data-pop-code]'));var s=getSelection();s.removeAllRanges();s.addRange(r)}
      return ok;
    }

    document.addEventListener('keydown',function(e){
      if(!isOpen||current!==root)return;
      if(e.key==='Escape'||e.key==='Esc'){e.preventDefault();close();return}
      if(e.key!=='Tab')return;
      var f=focusables();if(!f.length){e.preventDefault();box.focus(NS);return}
      var first=f[0],last=f[f.length-1],a=document.activeElement;
      if(e.shiftKey&&(a===first||!box.contains(a))){e.preventDefault();last.focus(NS)}
      else if(!e.shiftKey&&(a===last||!box.contains(a))){e.preventDefault();first.focus(NS)}
    });

    /* signing up in the footer counts too */
    document.addEventListener('submit',function(e){if(e.target&&e.target.matches&&e.target.matches('[data-news]'))remember('sub')},true);

    /* back from the form post (directly or through Shopify's challenge page): reopen on the right step */
    var pend=lsGet(PEND,sessionStorage),state=stateEl?stateEl.getAttribute('data-pop-state'):'',posted=/[?&]customer_posted=true/.test(location.search);
    if(pend&&Date.now()-pend.t<30*60*1000){
      if(posted||state==='posted'){pick(bySlug(pend.slug));success();return}
      if(state==='error'){
        var msg=stateEl.textContent.replace(/\s+/g,' ').trim();
        pick(bySlug(pend.slug));
        if(/taken|already/i.test(msg)){success();return}
        lsDel(PEND,sessionStorage);open(2);email.value=pend.email||'';showErr(msg);return;
      }
    }
    lsDel(PEND,sessionStorage);
    if(posted)remember('sub');

    if(design){
      root._ssOpen=function(){open(1)};
      document.addEventListener('shopify:section:select',function(e){if(e.detail&&e.detail.sectionId===d.section&&current===root)open(step)});
      document.addEventListener('shopify:section:deselect',function(e){if(e.detail&&e.detail.sectionId===d.section&&current===root)close()});
      if(force)open(1);
      return;
    }
    if(!force&&(d.enabled!=='true'||suppressed()||paid()))return;
    if(force){open(1);return}
    /* short page on a phone: a timer only, 45s, never scroll. tryOpen() waits while the bag, a modal or the menu is open. */
    if(SHORT){timer=setTimeout(tryOpen,45000);return}
    if(window.matchMedia&&matchMedia('(max-width:980px)').matches){
      /* phones: never at the desktop delay. Open after 20s once the visitor has scrolled at least 60% of a screen
         past the top Add to bag block (or 60% of a screen down on pages without one), or after 45s regardless.
         tryOpen() still waits while the cart drawer, a modal or the menu is open. */
      var t0=Date.now(),deep=false,MIN=20000,MAX=45000,iv=null;
      var past=function(){var q=document.querySelector('#view-pdp .qbuy'),r=q&&q.getClientRects().length?q.getBoundingClientRect():null;
        return r?r.bottom<=-0.6*window.innerHeight:window.scrollY>=0.6*window.innerHeight};
      var chk=function(){if(!deep&&past())deep=true;var el=Date.now()-t0;
        if((deep&&el>=MIN)||el>=MAX){window.removeEventListener('scroll',onS);clearInterval(iv);tryOpen()}};
      var onS=function(){if(!deep&&past()){deep=true;chk()}};
      window.addEventListener('scroll',onS,{passive:true});iv=setInterval(chk,1000);
    }else timer=setTimeout(tryOpen,delay);
    if(d.exit==='true'&&window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine) and (min-width:981px)').matches){
      document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0)tryOpen()});
    }
  }

  function boot(){init(document.querySelector('[data-ss-pop]'))}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(e){
    var r=e.target&&e.target.querySelector&&e.target.querySelector('[data-ss-pop]');
    if(r){current=null;init(r);if(r.dataset.design==='true'&&r._ssOpen)r._ssOpen()}
  });
})();
